import React from 'react'
import styled from 'styled-components'
import blackLogo from '@/assets/img/black.svg'
import logo from '@/assets/img/tripsha-logo-nobeta.png'

const Logo = styled.img`
  height: 40px;
  width: auto;
  float: left;
`

export const WhiteLogo = () => <Logo src={logo} />

export const BlackLogo = () => <Logo src={blackLogo} />
